import { queryClient, apiRequest } from "../lib/queryClient";

const petKey = "pet";

export function usePet(options = {}) {
  const {
    filters = {},
    sort = { field: "created_at", direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchPet = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);

    for (const [key, value] of Object.entries(filters)) {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    }
    const response = await apiRequest(
      `/admin/pet-store/?${queryParams.toString()}`,
      {
        method: "GET",
      }
    );
    return response;
  };

  const createPet = async (pageData) => {
    const response = await apiRequest("/admin/pet-store/", {
      method: "POST",
      body: JSON.stringify(pageData),
    });
    queryClient.invalidateQueries({ queryKey: [petKey] });
    return response;
  };

  const updatePet = async (pageData) => {
    const { _id, ...rest } = pageData;
    const response = await apiRequest(`/admin/pet-store//${_id}`, {
      method: "PUT",
      body: JSON.stringify(rest),
    });
    queryClient.invalidateQueries({ queryKey: [petKey] });
    return response;
  };

  const deletePet = async (pageId) => {
    await apiRequest(`/admin/pet-store//${pageId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [petKey] });
    return pageId;
  };

  const togglePetStatus = async (id) => {
    const response = await apiRequest(`/admin/pet-store/${id}`, {
      method: "PATCH",
    });
    queryClient.invalidateQueries({ queryKey: [petKey] });
    return response;
  };

  const toggleDefaultPet = async (id) => {
    const response = await apiRequest(`/admin/pet-store/default/${id}`, {
      method: "PATCH",
    });
    queryClient.invalidateQueries({ queryKey: [petKey] });
    return response;
  };

  const toggleIsExclusive = async (id, allowExclusive) => {
    const response = await apiRequest(
      `/admin/pet-store/exclusive/${id}/${allowExclusive ? "allow" : "deny"}`,
      {
        method: "PATCH",
      }
    );
    queryClient.invalidateQueries({ queryKey: [petKey] });
    return response;
  };

  return {
    fetchPet,
    createPet,
    updatePet,
    deletePet,
    togglePetStatus,
    toggleDefaultPet,
    toggleIsExclusive,
  };
}
